import { render } from "./UiConfirm.vue?vue&type=template&id=0c7b3888&scoped=true"
import script from "./UiConfirm.vue?vue&type=script&lang=js"
export * from "./UiConfirm.vue?vue&type=script&lang=js"

import "./UiConfirm.vue?vue&type=style&index=0&id=0c7b3888&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c7b3888"]])

export default __exports__